import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { servicePageMap } from '../data/servicePages';
import './ServiceDetailPage.css';

export default function ServiceDetailPage() {
  const { serviceSlug } = useParams();
  const page = servicePageMap[serviceSlug];

  if (!page) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="service-detail">
      <header className="service-detail__nav">
        <BrandLogo className="service-detail__brand" size="nav" />
        <Link to="/" className="service-detail__back">
          Back to Home
        </Link>
      </header>

      <section className="service-detail__hero">
        <div className="service-detail__hero-visual">
          <div className="service-detail__image-placeholder">Image placeholder</div>
        </div>
        <div className="service-detail__hero-content">
          <p className="service-detail__eyebrow">{page.eyebrow}</p>
          <h1 className="service-detail__title">
            {page.heroTitle[0]}
            <br />
            <em>{page.heroTitle[1]}</em>
            <br />
            {page.heroTitle[2]}
          </h1>
          <p className="service-detail__description">{page.heroDescription}</p>
          <div className="service-detail__stats">
            {page.heroStats.map((stat) => (
              <div key={stat.label} className="service-detail__stat">
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-detail__marquee">
        {page.marquee.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </section>

      <section className="service-detail__section">
        <h2>{page.serviceHeading}</h2>
        <div className="service-detail__grid">
          {page.services.map((service, index) => (
            <article key={service.title} className="service-detail__card">
              <p className="service-detail__card-index">{String(index + 1).padStart(2, '0')}</p>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="service-detail__section">
        <h2>{page.showcaseHeading}</h2>
        <div className="service-detail__grid service-detail__grid--showcase">
          {page.showcase.map((item) => (
            <article key={item.title} className="service-detail__card">
              <div className="service-detail__showcase-visual">Image placeholder</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="service-detail__section">
        <h2>Client Perspective</h2>
        <div className="service-detail__grid service-detail__grid--testimonials">
          {page.testimonials.map((testimonial, index) => (
            <blockquote key={testimonial} className="service-detail__quote">
              <p>"{testimonial}"</p>
              <cite>Perspective {index + 1}</cite>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="service-detail__cta">
        <h2>{page.ctaTitle}</h2>
        <Link to="/#contact" className="service-detail__cta-button">
          {page.ctaHighlight}
        </Link>
      </section>
    </div>
  );
}
